import { Component, Input, Inject, Renderer2, OnChanges } from '@angular/core';
import { IhmSidenavLink } from './ihm-sidenav.interface';
import { DOCUMENT } from '@angular/common';

// @dynamic
@Component({
  selector: 'ihm-sidenav',
  templateUrl: './ihm-sidenav.component.html',
  styleUrls: ['./ihm-sidenav.component.scss']
})
export class IhmSidenavComponent implements OnChanges {
  @Input() links: IhmSidenavLink[];
  @Input() bottomLinks: IhmSidenavLink[];
  @Input() theme = 'dashboard';
  @Input() tooltipDisabled = true;

  expanded = false;
  showLinkNames = false;

  constructor(@Inject(DOCUMENT) private document: any, private renderer: Renderer2) {}

  private SIDEBAR_VISIBLE: string = 'old-sidenav-visible';

  public ngOnChanges(): void {
    if (this.links && this.links.length) {
      this.renderer.addClass(this.document.body, this.SIDEBAR_VISIBLE);
    } else {
      this.renderer.removeClass(this.document.body, this.SIDEBAR_VISIBLE);
    }
  }

  public toggleExpanded() {
    this.expanded = !this.expanded;

    if (this.expanded) {
      this.renderer.addClass(this.document.body, 'sidenav-expanded');
      // when opening, we don't want these to appear until after the animation is complete
      // so the 300ms must match the animation duration
      setTimeout(() => {
        this.showLinkNames = this.expanded;
      }, 300);
    } else {
      this.showLinkNames = this.expanded;
      this.renderer.removeClass(this.document.body, 'sidenav-expanded');
    }
  }
}
